import React, { useEffect, useRef, useState } from "react";
import { Box, Container, Typography, Grid } from "@mui/material";


const useCountUp = (end: number, start: boolean) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;

    let current = 0;
    const duration = 2000;
    const increment = end / (duration / 16);

    const timer = setInterval(() => {
      current += increment;
      if (current >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end, start]);

  return count;
};

const SolidLuxuryCards = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  /* 🔥 TRIGGER */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const deals = useCountUp(2500, visible);
  const clients = useCountUp(1000, visible);
  const years = useCountUp(15, visible);
  const mentors = useCountUp(100, visible);

  return (
    <Box
      ref={ref}
      sx={{ background: "#ffffff", py: 8, px: { xs: 5, lg: "auto" } }}>
      <Container maxWidth="lg">

        {/* Heading */}
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            sx={{

              fontWeight: 600,
              color: "#0f172a",
            }}
          >
            Proven Results
          </Typography>

          <Typography sx={{ mt: 2, color: "#64748b" }}>
            From struggling closures to premium clients
          </Typography>
        </Box>

        {/* 🔥 TOP HERO */}
        <Box
          sx={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(40px)",
            transition: "all 1s ease",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "3rem", md: "5.5rem" },
              fontWeight: 700,
              fontFamily: "Playfair Display, serif",
              background:
                "linear-gradient(180deg, #0f6ab4, #3689ce)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {/* {deals}Cr+ */}
            {years}+
          </Typography>

          <Typography sx={{ color: "#0f63a5", }}>
            {/* Sales Volume Closed */}
            Years Experience
          </Typography>
        </Box>

        {/* 🔥 VERTICAL LINE */}
        <Box
          sx={{
            width: "2px",
            height: "80px",
            background:
              "linear-gradient(to bottom, #0f63a5, transparent)",
            mx: "auto",
            // my: 6,
            opacity: visible ? 1 : 0,
            transition: "all 1s ease 0.3s",
          }}
        />

        {/* 🔥 TREE SPLIT */}
        <Box sx={{ position: "relative" }}>

          {/* HORIZONTAL LINE */}
          <Box
            sx={{
              position: "absolute",
              // top: "20px",
              left: "10%",
              right: "10%",
              height: "2px",
              // background:
              //   "linear-gradient(to right, transparent, #0f63a5, transparent)",
              background: "#0f63a5",
              opacity: visible ? 1 : 0,
              transition: "all 1s ease 0.5s",
            }}
          />

          {/* LEFT NODE */}
          <Box
            sx={{
              position: "absolute",
              left: "10%",
              top: 0,
              transform: "translateX(-50%)",
            }}
          >
            <Box
              sx={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#0f63a5",
                boxShadow: "0 0 15px rgba(15,99,165,0.8)",
                mx: "auto",
                mb: 2,
              }}
            />

            <Typography
              variant="h2"
              sx={{
                // fontSize: "2rem",
                fontWeight: 700,
                color: "#0f63a5",
              }}
            >
              {/* {clients}+ */}
              {deals}Cr+
            </Typography>

            <Typography sx={{ color: "#0f63a5" }}>
              {/* Professionals Trained */}
              Sales Volume Closed
            </Typography>
          </Box>

          {/* 🔥 CENTER NODE */}
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              top: 0,
              transform: "translateX(-50%)",
              textAlign: "center",
            }}
          >
            {/* DOT */}
            <Box
              sx={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#0f63a5",
                boxShadow: "0 0 15px rgba(15,99,165,0.8)",
                mx: "auto",
                mb: 2,
              }}
            />

            {/* NUMBER */}
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                color: "#0f63a5",
              }}
            >
              
               {clients}+
            </Typography>

            {/* LABEL */}
            <Typography sx={{ color: "#0f63a5" }}>
              
               Professionals Trained
            </Typography>
          </Box>

          {/* RIGHT NODE */}
          <Box
            sx={{
              position: "absolute",
              right: "10%",
              top: 0,
              transform: "translateX(50%)",
            }}
          >
            <Box
              sx={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#0f63a5",
                boxShadow: "0 0 15px rgba(15,99,165,0.8)",
                mx: "auto",
                mb: 2,
              }}
            />

            <Typography
              variant="h2"
              sx={{
                // fontSize: "2rem",
                fontWeight: 700,
                color: "#0f63a5",
              }}
            >
              {/* {years}+ */}
             {mentors}+
            </Typography>

            <Typography sx={{ color: "#0f63a5" }}>
              {/* Years Experience */}
             Mentor 1:1
            </Typography>
          </Box>

          {/* SPACING FIX */}
          <Box sx={{ height: "120px" }} />
        </Box>

      </Container>
    </Box>
  );
};

export default SolidLuxuryCards;